module.exports = __webpack_public_path__ + "img/chevron-right.19f644ae.svg";